module.exports = "/_next/static/images/no-result-en-d54ad0db672c718f6b8814528bf180ec.svg";